// extracted by mini-css-extract-plugin
export var primary = "directions-module--primary--yIehg";
export var sectionWrapper = "directions-module--section-wrapper--a5YZ6";
export var directions = "directions-module--directions--YAVbP";
export var title = "directions-module--title--zDwgC";
export var secondary = "directions-module--secondary--NAOMu";
export var buttonsWrapper = "directions-module--buttons-wrapper--mf0LY";
export var link = "directions-module--link--aqFxy";